import createDuck from '../../../lib/ducks/remoteDuck'
import Return from '../../../lib/api/return'

export default createDuck({
  namespace: 'content',
  store: 'refundMethods',
  fetchCallback: Return.handleFetch,
})
